module.exports = __webpack_public_path__ + "assets/img/yuwell.01711a42.png";